// @flow
import { merge } from 'lodash';

import { appQueryParameters } from '@clubmed/utils';

import { convertLocationToURI } from 'Utils/uri/uriUtils';

export const getLegacyResortRedirectUrl = (location: RouterLocation<UrlParams, QueryParams>) =>
  convertLocationToURI(location)
    .query(`${appQueryParameters.legacy.be}`)
    .hash('#booking')
    .toString();

const NO_TRANSPORT_VALUE = 'NO';

export type ProductBookingDescriptorProps = {
  checkPriceLabel: string,
  enableTransfer: boolean,
  minAgeErrorMessage: string,
  minAgeInformation: string,
  package: {
    errorMessageNoMorePackages: string,
    errorMessageNoProposal: string,
  },
  resortId: string,
};

export type ProductBookingLineProps = {
  ...$Exact<ProductBookingDescriptorProps>,
  bookingCriteria: {
    departureCities: Array<{
      value: string,
      name: string,
    }>,
    durations: Array<number>,
    initialTransport: number,
    initialDuration: number,
    initialNumberOfAdults: number,
    initialNumberOfChildren: number,
  },
  config: CMSContent,
  legalInformations: {
    bookingProcess: Array<{ id: string, description: string }>,
  },
  resort: null | $Shape<Resort>,
};

export const getBookingConfig = (props: ProductBookingLineProps) => {
  const {
    checkPriceLabel,
    config,
    enableTransfer,
    minAgeErrorMessage,
    minAgeInformation,
    package: bookingPackage,
    resortId,
  } = props;
  return {
    ...config,
    booking: merge(config.booking, {
      checkPriceLabel,
      departureCity: NO_TRANSPORT_VALUE,
      enableTransfer,
      minAgeErrorMessage,
      minAgeInformation,
      package: bookingPackage,
      resortId,
    }),
  };
};
